import { useEffect, useState } from 'react'

import { mixOther } from 'api/mixOther'

type Home = {
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
    images_partner: string;
    title_partner: string;
    content_partner: string;
};

export default function UuDaiHangHang() {

    const [home, setHome] = useState<Home | null>(null)

    useEffect(() => {
        const loadOther = async () => {
            const res = await mixOther("sshome", "vi")
            if (!res?.status || !res.data?.json) {
                return;
            }

            try {
                const parsed = JSON.parse(res.data.json);
                setHome((prev) => ({ ...prev, ...parsed }));
            } catch (error) {
                console.error("Failed to parse setting JSON:", error);
            }
        };

        loadOther();
    }, [])

    // useEffect(()=> {
    //     console.log(home)
    // },[home])

    return (
        <div className="!mt-6">
            <div className="MuiContainer-root styles_boxContainer__ImgbB MuiContainer-maxWidthLg md:!pl-0 md:!pr-0">
                <div className="styles_companyIntroduction__h04I7">
                    <div className="styles_title__JlrYL">
                        <div className="styles_companyTitle__W3WKs">
                            <span dangerouslySetInnerHTML={{ __html: home?.title_partner || '' }} />
                        </div>
                        <svg
                            className="styles_vector__ifrV4"
                            width="202"
                            viewBox="0 0 200 4"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 2H200"
                                stroke="currentColor"
                                strokeWidth="4"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>

                <div className="MuiGrid-root styles_gridImagesWrapper__qs46T MuiGrid-container">
                    <div
                        className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                        style={{
                            position: "relative",
                            width: "100%",
                            height: "0px",
                            paddingBottom: "48.3592%",
                        }}
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "absolute",
                                inset: "0px",
                            }}
                        >
                            <img
                                src={ home?.images_partner }
                                decoding="async"
                                loading="lazy"
                                data-nimg="fill"
                                alt="Partners"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </span>
                    </div>
                </div>

                <div className="MuiGrid-root styles_centerContent__gI6Sf MuiGrid-item MuiGrid-grid-xs-12">
                    <p dangerouslySetInnerHTML={{ __html: home?.content_partner || '' }}></p>
                </div>

                <div className="MuiGrid-root styles_centerContent__gI6Sf MuiGrid-item MuiGrid-grid-xs-12">
                    <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btn__ShfUU hover:!bg-[var(--primary-color)] hover:opacity-70"
                        tabIndex={0}
                        type="button"
                    >
                        <span className="MuiButton-label">Tìm hiểu thêm</span>
                        <span className="MuiTouchRipple-root"></span>
                    </button>
                </div>
            </div>
        </div>
    );
}